import React from "react";
import { Skeleton } from "@mui/material";
import { Stack } from "@mui/material";

const SkltonPage = () => {
  return (
    <>
      <Stack spacing={1}>
        <Skeleton variant="h1" sx={styling} />
        <Skeleton variant="h5" sx={styling} />
        <Skeleton variant="h1" sx={styling} />
        <Skeleton variant="h3" sx={styling} />
        <Skeleton variant="rectangular" width="100%" height={358} />
      </Stack>
      <Stack spacing={1}>
        <div style={{ display: "flex", flexWrap: "wrap",gap:"4rem",margin:"3rem auto" }}>
          <Skeleton variant="circular" width={120} height={120} />
          <Skeleton variant="circular" width={120} height={120} />
          <Skeleton variant="circular" width={120} height={120} />
          <Skeleton variant="circular" width={120} height={120} />
          <Skeleton variant="circular" width={120} height={120} />
          <Skeleton variant="circular" width={120} height={120} />
        </div>
      </Stack>
    </>
  );
};

export default SkltonPage;

const styling = {
  // backgroundColor: "#666",
  height: "40px",
};
